import { apiClient, type DispatchListWithOrderExEntity } from '@/libs/api'
import { type DispatchesRequestQuery } from '@/libs/api/types'

export type FetchDispatchesQuery = {
  tenantKey: string
  query: DispatchesRequestQuery & {
    daysToFetch?: number
  }
  enabled?: boolean
}

export type FetchDispatchesResponse = {
  data: DispatchListWithOrderExEntity
}

export const fetchDispatches = async (
  { tenantKey, query }: FetchDispatchesQuery,
  signal?: AbortSignal
): Promise<FetchDispatchesResponse> => {
  const data = await apiClient._tenant(tenantKey).dispatches.$get({
    query,
    config: {
      signal
    }
  })

  return data
}
